// extracted by mini-css-extract-plugin
export var actions = "_3x-0";
export var actionsContainer = "_3x-6";
export var border = "_3x-1";
export var childFullHeight = "_3x-d";
export var collapse = "_3x-2";
export var content = "_3x-8";
export var contentChild = "_3x-c";
export var fullscreen = "_3x-a";
export var headerContainer = "_3x-3";
export var headerRow = "_3x-5";
export var hidePadding = "_3x-9";
export var noScrollX = "_3x-e";
export var noScrollY = "_3x-f";
export var optOutTopPadding = "_3x-b";
export var pagePadding = "_3x-7";
export var profile = "_3x-g";
export var profileContainer = "_3x-h";
export var profileImage = "_3x-i";
export var profileMain = "_3x-j";
export var profileSubtitle = "_3x-l";
export var profileTitle = "_3x-k";
export var tabsWrapper = "_3x-4";
export var title = "_3x-m";